import React, { forwardRef } from 'react'
import { observer } from 'mobx-react'
import * as defaultConst from '../../../constants/default_constants'

const EnumEdit = observer(forwardRef(({ enm, store, inside, enumValue }, ref) => {
  function _onClick (e) {
    e.preventDefault()
    if (store.openEnumItem && store.openEnumItem === enm.value) {
      store.openEnumItem = false
      store.cv.loadEnums({})
    } else {
      store.openEnumItem = enm.value
      store.cv.loadEnums(enm)
    }
  }
  const enabled = store.hasRight('enums', 'w')

  return (
    <div ref={!enumValue ? ref : undefined} className='panel panel-default'>
      <div className='panel-heading' role='tab'>
        <h5 className='panel-title'>
          <div className='pull-right'>
            {!inside && <button type='button' className='btn btn-default btn-xs add-rmargin' onClick={_onClick}>
              <em className='glyphicon glyphicon-list' />&nbsp;{store.__(defaultConst.TITLE_LIST)}
            </button>}&nbsp;
            <button type='button' disabled={!enabled} className='btn btn-info btn-xs add-rmargin' onClick={() => store.cv.editEnumItem(enm)}>
              <em className='glyphicon glyphicon-edit' />&nbsp;{store.__(defaultConst.TITLE_EDIT)}
            </button>&nbsp;
            {!inside && <button type='button' disabled={!enabled} className='btn btn-primary btn-xs' onClick={() => store.cv.addEnumItem(enm)}>
              <em className='glyphicon glyphicon-plus-sign' />&nbsp;{store.__(defaultConst.TITLE_ADD)}
            </button>}
          </div>
          {!inside
            ? (
              <a
                href='#'
                className={store.openEnumItem === enm.value
                  ? 'dropdown enum-item-decoration'
                  : 'dropdown enum-item-decoration'}
                onClick={_onClick}>
                <strong>{enm.text}</strong>&nbsp;
                <span className='label label-default'>{enm.value}</span>
                <span className='caret' />
              </a>
            )
            : (
              enabled ? (
                <a href='#' className='enum-item-wrap enum-item-decoration' onClick={() => store.cv.editEnumItem(enm)}>
                  <strong>{enm && enm.text}</strong>&nbsp;
                  <span className='label label-default'>{enm && enm.value}</span>
                </a>
              ) : (
                <div>
                  <strong>{enm && enm.text}</strong>&nbsp;
                  <span className='label label-default'>{enm && enm.value}</span>
                </div>
              )
            )
          }
        </h5>
      </div>
      {enm && (enm.children.length === 0 || enm.children.length > 1000)
        ? null
        : (
          <div className='collapse in' role='tabpanel'>
            <div className='card-block' style={{
              padding: '1.5em'
            }}>
              {enm.children.map((i, idx) => {
                if (enumValue && i.value === enumValue) {
                  store.cv.editEnumItem(i)
                }
                return <EnumEdit enm={i} store={store} key={idx} inside
                  ref={enumValue && i.value === enumValue ? ref : undefined} />
              })
              }
            </div>
          </div>
        )
      }
    </div>
  )
}))

export default EnumEdit
